
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { Meta } from '@storybook/addon-docs';
import tokens from '../compiled/tokens/js/tokens.js';
const ratio = tokens.number.scale.modular.ratio.value;
const minimumStep = tokens.number.scale.modular.minimum_step.value;
const maximumStep = tokens.number.scale.modular.maximum_step.value;
const sizeRows = [];
for (let i = minimumStep; i <= maximumStep; i++) {
  // `toFixed` keeps the values from extending past two decimal points.
  // The `Number` constructor prevents unnecessary decimals from displaying,
  // for example `1.00` instead of `1`.
  const size = `${Number((ratio ** i).toFixed(2))}em`;
  const row = (
    <tr>
      <td>{i}</td>
      <td>{size}</td>
      <td style={{ width: '90%' }}>
        <div
          style={{
            background: 'currentColor',
            height: '1em',
            opacity: 0.66,
            width: size,
          }}
        ></div>
      </td>
    </tr>
  );
  sizeRows.push(row);
}


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Design/Modular Scale" mdxType="Meta" />
    <h1>{`Modular Scale`}</h1>
    <p>{`Most typographic and whitespace measurements in our patterns are based on steps of `}<a parentName="p" {...{
        "href": "/docs/design-tokens-modular-scale--page"
      }}>{`our modular scale`}</a>{`. This has several benefits for text-heavy projects like ours:`}</p>
    <ul>
      <li parentName="ul">{`Encourages designers to think in terms of relative proportion rather than hard-set sizes, which makes patterns more versatile in responsive designs.`}</li>
      <li parentName="ul">{`Minimizes loss of text alignment in complex layouts.`}</li>
      <li parentName="ul">{`Avoids the need to define every step of a scale individually.`}</li>
      <li parentName="ul">{`Ensures the relationship between successive steps is predictable and clear.`}</li>
    </ul>
    <p>{`To learn more about modular scales, we recommend reading `}<a parentName="p" {...{
        "href": "https://alistapart.com/article/more-meaningful-typography/"
      }}>{`More Meaningful Typography`}</a>{` by Tim Brown.`}</p>
    <h2>{`Sizes`}</h2>
    <table>
  <thead>
    <tr>
      <th>Step</th>
      <th>Size</th>
      <th></th>
    </tr>
  </thead>
  <tbody>{sizeRows}</tbody>
    </table>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

export const __page = () => { throw new Error("Docs-only story"); };

__page.parameters = { docsOnly: true };

const componentMeta = { title: 'Design/Modular Scale', includeStories: ["__page"],  };

const mdxStoryNameToKey = {};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;